export default __webpack_public_path__ + "static/media/plusLight.60aebb9f.svg";